import { render } from "./detail-ftz-section.vue?vue&type=template&id=5a4fc068&scoped=true&ts=true"
import script from "./detail-ftz-section.vue?vue&type=script&lang=ts"
export * from "./detail-ftz-section.vue?vue&type=script&lang=ts"

import "./detail-ftz-section.vue?vue&type=style&index=0&id=5a4fc068&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4fc068"]])

export default __exports__